<script setup lang="ts">
import DeviceActions from '@/components/DeviceComponents/DeviceActions.vue'
import DeviceInformations from '@/components/DeviceComponents/DeviceInformations.vue'
import { type DeviceProviderType, EProviders } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'

provide<DeviceProviderType>(EProviders.DEVICE, {
    DeviceInformations: DeviceInformations
})
</script>

<template>
    <slot />
</template>
